import { __awaiter } from "tslib";
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ReducerType } from './types';
const initialState = {
    loading: 'idle',
    error: null,
    entity: null
};
export var ValidTimesActionType;
(function (ValidTimesActionType) {
    ValidTimesActionType["FetchValidTimes"] = "validTimes/fetchValidTimes";
})(ValidTimesActionType || (ValidTimesActionType = {}));
export const fetchValidTimes = createAsyncThunk(ValidTimesActionType.FetchValidTimes, (orderType, { getState, rejectWithValue }) => __awaiter(void 0, void 0, void 0, function* () {
    const { api } = getState().config;
    if (!api)
        return;
    try {
        const validTimes = yield api.getValidTimes(orderType);
        return validTimes;
    }
    catch (err) {
        return rejectWithValue(err);
    }
}));
const validTimesSlice = createSlice({
    name: ReducerType.ValidTimes,
    initialState,
    reducers: {
        resetValidTimes: () => initialState,
        setValidTimes: (state, action) => {
            state.entity = action.payload;
        }
    },
    extraReducers: builder => {
        builder
            .addCase(fetchValidTimes.fulfilled, (state, action) => {
            state.entity = action.payload;
            state.loading = 'idle';
            state.error = null;
        })
            .addCase(fetchValidTimes.pending, state => {
            state.loading = 'pending';
        })
            .addCase(fetchValidTimes.rejected, (state, action) => {
            state.loading = 'idle';
            state.error = action.payload;
        });
    }
});
export const { resetValidTimes, setValidTimes } = validTimesSlice.actions;
export const selectValidTimes = (state) => state.validTimes;
export const validTimesReducer = validTimesSlice.reducer;
